import { useSelector } from "react-redux";
import "./style.css"

function Message() {
    const msg = useSelector(state => state.site.message);

    return msg && msg !== '' && (
        <div className="alert_message">
            <div className="content">
                <p>{msg}</p>
            </div>
        </div>
    )
}

export default Message;